import { Injectable } from '@angular/core';
import { iBisEditService, iBisLanguageService } from '@dohu/ibis-common';
import { EntityQuery, iBisEntityService } from '@dohu/ibis-entity';

@Injectable({
  providedIn: 'root'
})
export class RfqEditItemListTechnicalSelectionService extends iBisEditService {
  data!: any;
  initialData!: any;
  rfqItemId!: string;
  constructor(lg: iBisLanguageService, private entity: iBisEntityService) {
    super(lg);
    this.title = this.L('COMMITTEE');
  }

  createDefault() {
    return {};
  }
  getById(id: string, serverUrl?: string | undefined): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getData(id).then(dtResp => {
        this.rfqItemId = id;
        this.data = [...dtResp.map(x => x.userId)];
        this.initialData = [...dtResp];
        resolve(true);
      })
    })
  }
  override onRemove(_id: string): Promise<void> {
    return Promise.reject('Method not implemented.');
  }
  onSaveEv(serverUrl?: string | undefined): Promise<any> {
    if (this.data.length == 0 || !this.rfqItemId) { return Promise.reject('Invalid params.'); }
    const insertData = this.data.filter((x: string) => !this.initialData.map((x: any) => x.userId).includes(x));
    const deleteData = this.initialData.filter((x: any) => !this.data.includes(x.userId));
    const saves = insertData.map((tuID: string) => this.entity.save('TechUser', null, { rfqItemId: this.rfqItemId, userId: tuID }));
    const deletes = deleteData.map((tu: any) => this.entity.remove('TechUser', tu.id));
    return Promise.all([...saves, ...deletes]);
  }
  override reset(): void {
    this.model = this.createDefault();
  }

  public getData(rfqItemId: string): Promise<any[]> {
    const q = new EntityQuery("TechUser").eq('rfqItemId', rfqItemId).addOrderByDesc(['userId']);
    return this.entity.load(q);
  }

}
